import React from "react";
import { HashLoader } from "react-spinners";

const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      width: "100%",
      justifyContent: "center",
      marginTop: "5rem",
    }}
  >
    <HashLoader size={100} color="#18b3ab" />
  </div>
);

export default LoadingSpinner;
